enum RewardType {
    Claims = 'Claims',
    Catalog = 'Catalog',
}

export default RewardType;
